module.exports = __webpack_public_path__ + "static/finovate-spring-2015-f95aabfb0f21d7ee72749608a985433a.png";